import { Stethoscope } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/components/dialogue/radix-dialog';
import EditDietForm from './edit-diet-form';
import { DietReport } from 'src/redux/types/_customer.type';

const EditDietDialog = ({
  report,
  memberId,
  open,
  close,
}: {
  report: DietReport;
  memberId: number;
  open: boolean;
  close: () => void;
}) => {
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="bg-white min-w-5xl max-w-5xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-center">
            <h2 className="font-medium text-[#42679e] text-xl border-b flex items-center justify-center gap-3">
              <Stethoscope size={20} /> <span>Edit Diet Report</span>
            </h2>
          </DialogTitle>
        </DialogHeader>

        <EditDietForm report={report} memberId={memberId} close={close}/>
      </DialogContent>
    </Dialog>
  );
};

export default EditDietDialog